import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    height: '100%',
    padding: '0rem 1.6rem',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    margin: '2rem 0',
    justifyContent: 'space-between',

    [$theme.mediaQuery.large]: {
        width: '37.5rem',
        margin: '4rem auto',
        flexGrow: 0
    }
}))

export const ButtonsWrapper = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
}))

export const Title = styled('div', ({ $theme }) => ({
    ...$theme.typography.HeadingLarge,
    fontWeight: 600,
    textAlign: 'center',
    [$theme.mediaQuery.large]: {
        marginLeft: '33.4rem',
        textAlign: 'left'
    }
}))

export const LogoutMobileButton = styled('button', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    backgroundColor: $theme.colors.white,
    textAlign: 'center',
    padding: '1.3rem 0',
    borderRadius: '5rem',
    border: `1px solid #FE2C3E`,
    width: '100%',
    color: '#FE2C3E',
    display: 'flex',
    justifyContent: 'center',
    gap: '1.6rem',
    alignItems: 'center',
    fontWeight: 500,
    cursor: 'pointer',
    marginBottom: '4rem',

    [$theme.mediaQuery.large]: {
        marginTop: '4rem',
        width: '33.5rem'
    }
}))
